import React from 'react';
import {
	styled,
	ParentBoundComponent
} from 'ps-gui';

import NotificationModel from './notificationmodel';

const Wrapper = styled.div`
`;

export default class NotificationModule extends ParentBoundComponent {

	getModel() {
		return new NotificationModel(this.getData());
	}

	setModel(model) {
		this.setData(model.getData());
	}

	render() {
		return (
			<Wrapper>
				notifications
			</Wrapper>
		);
	}
}

